import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "19",
  fill: "currentColor",
  viewBox: "0 0 20 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M11.948 1.875c-.866-1.5-3.03-1.5-3.897 0l-7.505 13c-.867 1.5.216 3.375 1.948 3.375h15.011c1.732 0 2.815-1.875 1.949-3.375zm-2.598.75a.75.75 0 0 1 1.3 0l7.505 13a.75.75 0 0 1-.65 1.125H2.495a.75.75 0 0 1-.65-1.125zM10 6.561a.75.75 0 0 1 .75.75v4.22a.75.75 0 0 1-1.5 0V7.31a.75.75 0 0 1 .75-.75m-.9 7.52a.9.9 0 1 1 .9.9.9.9 0 0 1-.9-.9",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }